import { loginConstants } from "./types";
import {
  authenticate,
  controlCandidate,
  addLead,
  authenticateOtpService,
  authenticateVerifyService,
  resetPasswordWithSms,
  refreshToken
} from "../../../services/login.service";
import { alertActions } from "../alert/actions";

const beginAuthenticate = (data) => {
  return (dispatch) => {
    if (data.username === "" || data.password === "") {
      dispatch(alertActions.showError("Kullanıcı adı ve şifrenizi giriniz."));
      return;
    }
    dispatch(request(data.username));
    authenticate(data).then(
      (login) => {
        sessionStorage.setItem("token", login.token);
        dispatch(success(login));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(login) {
    return { type: loginConstants.LOGIN_REQUEST, login };
  }
  function success(login) {
    return { type: loginConstants.LOGIN_SUCCESS, login };
  }
  function failure(error) {
    return { type: loginConstants.LOGIN_FAILURE, error };
  }
};

const authenticateOtp = (data) => {
  return (dispatch) => {
    if (data.username === "" || data.password === "") {
      dispatch(alertActions.showError("Kullanıcı adı ve şifrenizi giriniz."));
      return;
    }
    dispatch(request(data.username));
    authenticateOtpService(data).then(
      (login) => {
        if (login.success) {
          if (login.data.otpType == 0) {
            sessionStorage.setItem("token", login.data.token);
            sessionStorage.setItem("refreshToken", login.data.refreshToken);
            sessionStorage.setItem("tokenExpireTime", (login.data.tokenExpireTime * 60).toString())
            // sessionStorage.setItem("tokenExpireTime", (60).toString())
            dispatch(success(login.data));
          }
          else if (login.data.otpType == -1) {
            dispatch(ExpirePassword(login.message, Date.now(), data.username, data.password, login.data));
          }
          else {
            if (data.verifyType == 1) {
              dispatch(showVerify(login.message, Date.now(), data.username, data.password));
            } else if (data.verifyType == 2) {
              dispatch(showVerifyEposta(login.message, Date.now(), data.username, data.password));
            }
          }
        } else {
          dispatch(failure(login.message));
          dispatch(alertActions.showError(login.message));
        }
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(login) {
    return { type: loginConstants.LOGIN_OTP_REQUEST, login };
  }
  function success(login) {
    return { type: loginConstants.LOGIN_OTP_SUCCESS, login };
  }
  function failure(error) {
    return { type: loginConstants.LOGIN_OTP_FAILURE, error };
  }
  function showVerify(response, countDate, username, password) {
    return {
      type: loginConstants.LOGIN_OTP_SMSVERIFY,
      payload: {
        response,
        countDate,
        username,
        password
      },
    };
  }
  function showVerifyEposta(response, countDate, username, password) {
    return {
      type: loginConstants.LOGIN_OTP_EPOSTAVERIFY,
      payload: {
        response,
        countDate,
        username,
        password
      },
    };
  }
  
  function ExpirePassword(response, countDate, username, password, data) {
    return {
      type: loginConstants.LOGIN_OTP_EXPIREPASSWORD,
      payload: {
        response,
        countDate,
        username,
        password,
        data
      },
    };
  }
};

const authenticateVerify = (data) => {
  return (dispatch) => {

    if (data.smsCode === "" || data.smsCode.length < 6) {
      dispatch(alertActions.showError("Doğrulama kodu hatalı"));
      return;
    }
    dispatch(request(data.username));
    authenticateVerifyService(data).then(
      (login) => {
        if (login.success) {
          sessionStorage.setItem("token", login.data.token);
          sessionStorage.setItem("refreshToken", login.data.refreshToken);
          sessionStorage.setItem("tokenExpireTime", (login.data.tokenExpireTime * 60).toString())
          dispatch(success(login.data));
        } else {
          dispatch(failure(login.message));
          dispatch(alertActions.showError(login.message));
        }
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(login) {
    return { type: loginConstants.LOGIN_VERIFY_REQUEST, login };
  }
  function success(login) {
    return { type: loginConstants.LOGIN_VERIFY_SUCCESS, login };
  }
  function failure(error) {
    return { type: loginConstants.LOGIN_VERIFY_FAILURE, error };
  }
};

const beginControlCandidate = (postData) => {
  return (dispatch) => {
    dispatch(request("beginControlCandidate"));
    controlCandidate(postData).then(
      (response) => {
        if (response?.data?.code === 2) {
          dispatch(success(response, postData.username, Date.now()));
        }
        else if (response?.data?.code === 66) {
          dispatch(successNew(response, postData.username));
        }
        else {
          var error =
            response?.data?.return !== null
              ? response?.data?.return
              : "Beklenmeyen bir hata oluştu.";
          dispatch(failure(error));
          dispatch(alertActions.showError(error));
        }
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(response) {
    return {
      type: loginConstants.LOGIN_CANDIDATE_REQUEST,
      payload: { response },
    };
  }
  function success(response, newCandidate, countDate) {
    return {
      type: loginConstants.LOGIN_CANDIDATE_SUCCESS,
      payload: {
        response,
        newCandidate,
        countDate,
      },
    };
  }
  function successNew(response, newCandidate) {
    return {
      type: loginConstants.LOGIN_CANDIDATE_SUCCESS_NEW,
      payload: {
        response,
        newCandidate
      },
    };
  }
  function failure(error) {
    return { type: loginConstants.LOGIN_CANDIDATE_FAILURE, error };
  }
};

const clearCandidateRedirect = () => {
  return { type: loginConstants.CLEAR_CANDIDATE_REDIRECT };
};

const beginLogout = () => {
  return { type: loginConstants.LOGOUT };
};

const hideSmsModal = () => {
  return { type: loginConstants.HIDE_SMS_MODAL };
};



const beginAddLead = (data) => {
  return (dispatch) => {
    dispatch(request(data));
    addLead(data).then(
      (lead) => {
        if (lead?.responseCode === 200) {
          dispatch(success(lead));
          // dispatch(alertActions.success("Bilgileriniz başarılı şekilde alınmıştır. En kısa zamanda sizinle iletişime geçilecektir."));
        }
        else {
          var error =
            lead?.messages.length > 0
              ? lead?.messages[0]
              : "Beklenmeyen bir hata oluştu.";
          dispatch(failure(error));
          dispatch(alertActions.showError(error));
        }
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(lead) {
    return { type: loginConstants.ADD_LEAD_REQUEST, lead };
  }
  function success(lead) {
    return { type: loginConstants.ADD_LEAD_SUCCESS, lead };
  }
  function failure(error) {
    return { type: loginConstants.ADD_LEAD_FAILURE, error };
  }
};



const resetLeadSuccess = () => ({
  type: loginConstants.RESET_LEAD_SUCCESS,
});



const resetPasswordsWitSms = (data) => {
  return (dispatch) => {
    dispatch(request());
    resetPasswordWithSms(data).then(
      (response) => {
        if (response.success) {
          dispatch(success(response));
          dispatch(alertActions.success(response.message));
        } else {
          dispatch(alertActions.showError(response.message));
        }
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request() {
    return {
      type: loginConstants.RESET_PASSWORD_REQUEST,
    };
  }
  function success(response) {
    return {
      type: loginConstants.RESET_PASSWORD_SUCCESS,
      payload: { response },
    };
  }
  function failure() {
    return { type: loginConstants.RESET_PASSWORD_FAILURE };
  }
};

export {
  beginAuthenticate,
  beginControlCandidate,
  clearCandidateRedirect,
  beginLogout,
  hideSmsModal,
  beginAddLead,
  resetLeadSuccess,
  authenticateOtp,
  authenticateVerify,
  resetPasswordsWitSms,
  refreshToken
};
